export const CategoryRoute = {
  CATEGORIES: 'categories',
  CATEGORIESOVERVIEW: 'categoriesoverview',
  CATEGORYOVERVIEW: 'categoryoverview',
};

export const CategoryPathName = {
  CATEGORIES: 'categories',
  CATEGORIESDATAVIEWS: 'categoriesdataviews',
  CATEGORIESOVERVIEW: 'categoriesoverview',
  CATEGORYOVERVIEW: 'categoryoverview',
  CATEGORIESFORM_NEW: 'categoriesForm:new',
  CATEGORIESFORM: 'categoriesForm',
  CATEGORIESMETRIC: 'categoriesmetric',
  CATEGORIESDRILLDOWN: 'categoriesdrilldown',
};

export const CATEGORY_SAVE_EVENT = 'CategorySaveEvent';

export const Constants = {
  ID: 'id',
  NAME: 'name',
  CATEGORY_METRICS: 'category_metrics',
  PARENT_NAME: 'parent_name',
  LABEL: 'label',
  FIELD: 'field',
  MODEL: 'model',
  EXTENDED_ID: 'extended_id',
  DATASOURCE_PRIMARY_KEY: 'id',
  DATASOURCE_VALUE_KEY: 'name',
  CATEGORY_METRIC_PRIMARY_KEY: 'category_metric_id',
  CATEGORY_METRIC_VALUE_KEY: 'name',
};
